import React from 'react';
import { useTranslation } from 'react-i18next';
import '../i18n'; // important to import
const StudentTestimonials = () => {
    const { t } = useTranslation('StudentTestimonials');
    return (
        <>
            <section>
                <div className="testimonials-main position-relative">
                    <div className="container">
                        <div className="section-title col-md-12 col-lg-6 m-auto">
                            <span className="d-block">{t("studenttestimonials")} </span>
                            <h2>{t("hearfromourlearners")} </h2>
                        </div>
                        <div className="row row-cols-1 row-cols-md-2 row-cols-lg-2 row-cols-xl-3 g-4 mt-0 mt-md-5">
                            <div className="col">
                                <div className="card border-0 shadow-sm h-100">
                                    <div className="card-body">
                                        <img
                                            src="./png/twitter.png"
                                            className="card-img-top"
                                            alt="..."
                                        />
                                        <h5 className="text-black fw-600 my-4">
                                          {t("iabsolutelylovethisplatform")} {" "}
                                        </h5>
                                        <p className="text-muted fw-400">
                                            {t("thecoursesareengagingandwellstructuredmakinglearningenjoyable")}
                                        </p>
                                        <p className="text-primary fw-600 fs-18">Sara J.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col">
                                <div className="card border-0 shadow-sm h-100">
                                    <div className="card-body">
                                        <img
                                            src="./png/twitter.png"
                                            className="card-img-top"
                                            alt="..."
                                        />
                                        <h5 className="text-black fw-600 my-4">
                                            {t("funandeffectivelearning")}
                                        </h5>
                                        <p className="text-muted fw-400">
                                           {t("cardbody2des")}
                                        </p>
                                        <p className="text-primary fw-600 fs-18">Sara J.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col">
                                <div className="card border-0 shadow-sm h-100">
                                    <div className="card-body">
                                        <img
                                            src="./png/twitter.png"
                                            className="card-img-top"
                                            alt="..."
                                        />
                                        <h5 className="text-black fw-600 my-4">
                                          {t("icantsayenoughgoodthingsaboutthiselearningplatform")}
                                        </h5>
                                        <p className="text-muted fw-400">
                                            {t("cardbody3des")}
                                        </p>
                                        <p className="text-primary fw-600 fs-18">Jennifer T.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col">
                                <div className="card border-0 shadow-sm h-100">
                                    <div className="card-body">
                                        <img
                                            src="./png/twitter.png"
                                            className="card-img-top"
                                            alt="..."
                                        />
                                        <h5 className="text-black fw-600 my-4">
                                          {t("imsogladifoundthiselearningtool")}
                                        </h5>
                                        <p className="text-muted fw-400">
                                            {t("cardbody4des")}
                                        </p>
                                        <p className="text-primary fw-600 fs-18">Alex W.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col">
                                <div className="card border-0 shadow-sm h-100">
                                    <div className="card-body">
                                        <img
                                            src="./png/twitter.png"
                                            className="card-img-top"
                                            alt="..."
                                        />
                                        <h5 className="text-black fw-600 my-4">
                                           {t("asabusyprofessional")}
                                        </h5>
                                        <p className="text-muted fw-400">
                                          {t("cardbody5des")}
                                        </p>
                                        <p className="text-primary fw-600 fs-18">Mark L.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col">
                                <div className="card border-0 shadow-sm h-100">
                                    <div className="card-body">
                                        <img
                                            src="./png/twitter.png"
                                            className="card-img-top"
                                            alt="..."
                                        />
                                        <h5 className="text-black fw-600 my-4">
                                        {t("iabsolutelylovethisplatform")} {" "}
                                       
                                        </h5>
                                        <p className="text-muted fw-400">
                                            {t("thecoursesareengagingandwellstructuredmakinglearningenjoyable")}
                                        </p>
                                        <p className="text-primary fw-600 fs-18">Sara J.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default StudentTestimonials;
